export const routes = {
  HOMEPAGE: () => `/`,
  GALLERY: () => `/gallery`,
  CAREER: () => `/career`,
  BOOK: () => `/book`,
  LOGIN: () => `/login`,
  REGISTER: () => `/register`,
  PRICE_LIST: () => `/price-list`
};
